import { getNotifications, RequestOptions } from '@connect-x-app/hybrid-data-access';
import { ApiError, Notification, NotificationsResponse, QueryKeys } from '@connect-x-app/shared-domain-models';
import { DEFAULT_PAGE_SIZE, SortDescending } from '@connect-x-app/shared-utils';
import { InfiniteData, QueryFunctionContext, QueryKey, useInfiniteQuery } from '@tanstack/react-query';

import { useAuthentication } from '../useAuthentication';

const OPTIONS: RequestOptions<Notification> = {
  limit: DEFAULT_PAGE_SIZE,
  sort: [new SortDescending<Notification>('createdAt')],
};

export const useGetPaginatedNotifications = () => {
  const { user } = useAuthentication();

  return useInfiniteQuery<NotificationsResponse, ApiError, InfiniteData<NotificationsResponse>, QueryKey, number>({
    enabled: !!user,
    getNextPageParam: ({ items, limit, offset }) => {
      if (items?.length !== limit) {
        return undefined;
      }

      return offset + limit;
    },
    initialPageParam: 0,
    queryFn: (context: QueryFunctionContext<QueryKey, number>) =>
      getNotifications({
        ...OPTIONS,
        offset: context.pageParam,
      }),
    queryKey: [QueryKeys.NOTIFICATIONS],
  });
};
